// ----------------------------------------------------------------------
// Global Dashboard Translations - Italian
// ----------------------------------------------------------------------

export const globalDashboardIt = {
  global_dashboard: {
    // Page title
    page_title: 'Dashboard',

    // Welcome messages by role
    welcome: {
      owner: 'Gestisci la tua attività da qui',
      ambassador: 'Pronto a promuovere eventi straordinari?',
      referral: 'Scopri nuovi eventi da condividere e guadagnare',
      waiter: 'Gestiamo questi tavoli in modo efficiente',
      default: 'La tua dashboard è pronta',
    },

    // Contextual info alerts
    context_info: {
      event_mode_title: 'Focus Gestione Eventi',
      event_mode_description: 'Sei in modalità gestione eventi. Passa alla modalità ristorante o studio musicale nelle impostazioni se necessario.',
      restaurant_mode_title: 'Focus Gestione Ristorante',
      restaurant_mode_description: 'Sei in modalità gestione ristorante. Passa alla modalità eventi o studio musicale nelle impostazioni se necessario.',
      music_studio_mode_title: 'Focus Gestione Studio Musicale',
      music_studio_mode_description: 'Sei in modalità gestione studio musicale. Passa alla modalità eventi o ristorante nelle impostazioni se necessario.',
    },

    // Dashboard modules
    modules: {
      events_management: 'Gestione Eventi',
      events_description: 'Crea, gestisci e monitora i tuoi eventi',
      organizations: 'Organizzazioni',
      organizations_description: 'Gestisci le tue organizzazioni e impostazioni',
      restaurants: 'Ristoranti',
      restaurants_description: 'Gestisci ristoranti e menu',
      music_studios: 'Studi Musicali',
      music_studios_description: 'Gestisci studi di registrazione, prenotazioni e sessioni',
      network_team: 'Rete & Team',
      network_team_description: 'Invita utenti, gestisci il team e monitora le referenze',
      ambassador_events: 'Eventi Ambasciatore',
      ambassador_events_description: 'Visualizza e promuovi eventi come ambasciatore',
      my_events: 'I Miei Eventi',
      my_events_description: 'Monitora i tuoi eventi promossi e guadagni',
      table_management: 'Gestione Tavoli',
      table_management_description: 'Gestisci tavoli del ristorante e ordini',
    },

    // Quick actions
    quick_actions: {
      title: 'Azioni Rapide',
      create_event: 'Crea Evento',
      create_organization: 'Crea Organizzazione',
      invite_team: 'Invita Team',
      search_events: 'Cerca Eventi',
    },

    // Available modules section
    available_modules: 'Moduli Disponibili',

    // Buttons
    buttons: {
      open: 'Apri',
      manage: 'Gestisci',
      copy_link: 'Copia Link',
      share: 'Condividi',
      create_event: 'Crea Evento',
      create_event_org: 'Crea Org. Evento',
      create_studio: 'Crea Studio',
    },

    // Labels
    labels: {
      new: 'Nuovo',
      event_org: 'Org. Evento',
      studio: 'Studio',
    },

    // Enhanced events module
    events_module: {
      title: 'Gestione Eventi',
      recent_events: 'eventi recenti',
      click_to_manage: 'Clicca per gestire tutto',
      no_recent_events: 'Nessun evento recente',
      click_to_create: 'Clicca per creare il tuo primo evento',
      create_first_event: 'Crea il tuo primo evento per iniziare',
      more_events: 'più eventi',
    },

    // Event organizations module
    event_orgs_module: {
      title: 'Organizzazioni Eventi',
      recent_organizations: 'organizzazioni recenti',
      no_organizations: 'Nessuna organizzazione eventi ancora',
      create_first_org: 'Crea la tua prima organizzazione eventi',
      followers: 'follower',
    },

    // Music studios module
    music_studios_module: {
      title: 'Studi Musicali',
      recent_studios: 'studi recenti',
      no_studios: 'Nessuno studio musicale ancora',
      create_first_studio: 'Crea il tuo primo studio musicale',
      services: 'servizi',
    },

    // Invitation card
    invitation_card: {
      title: 'Invita alla Rete',
      description: 'Condividi il tuo link di invito',
      your_link: 'Il tuo link di invito:',
      link_copied: 'Link di invito copiato negli appunti!',
      link_copy_failed: 'Impossibile copiare il link',
      share_title: 'Unisciti alla Mia Rete',
      share_text: 'Unisciti alla mia rete e scopri eventi straordinari!',
    },

    // Contacts card
    contacts_card: {
      title: 'I Miei Contatti',
      description: 'Gestisci i tuoi contatti',
      access_list: 'Accedi alla tua lista contatti',
      add_new: 'Aggiungi nuovi contatti',
      send_messages: 'Invia email e messaggi',
    },

    // Event status chips
    event_status: {
      upcoming: 'prossimo',
      ongoing: 'in corso',
      past: 'passato',
    },

    // Mode chips
    mode: {
      event: 'Modalità Evento',
      music_studio: 'Modalità Studio Musicale',
      restaurant: 'Modalità Ristorante',
    },

    // Footer
    footer: {
      help_text: 'Hai bisogno di aiuto? Consulta la nostra documentazione o contatta il supporto.',
    },
  },
};

export default globalDashboardIt;
